<template>
  <div class="counterparties-list">
    <div class="counterparties-list_row head" v-if="clients.length">
      <div class="counterparties-list_col check">
        <b-form-checkbox v-model="allSelected" :indeterminate="indeterminate" @change="checkAll"></b-form-checkbox>
      </div>
      <div class="counterparties-list_col name">Company Name</div>
      <div class="counterparties-list_col full-name">Full Style</div>
      <div class="counterparties-list_col subtype">Subtype</div>
      <div class="counterparties-list_col broker">Broker</div>
      <div class="counterparties-list_col attachment">Attachments</div>
    </div>

    <div class="counterparties-list-empty" v-else>
      <svg width="320" height="160" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M269 123.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6zM56 33.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6zM216 18.2a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4zm0 1.8a3 3 0 100-6 3 3 0 000 6zM207.623 84.328a1 1 0 011-1h6.899c10.741 0 19.478 8.737 19.477 19.477v20.396c0 6.665-5.421 12.086-12.086 12.086h-13.365a1 1 0 110-2h13.365c5.561 0 10.086-4.526 10.086-10.086v-20.396c.001-9.636-7.841-17.477-17.477-17.477h-6.899a1 1 0 01-1-1zM97 102.81c0-10.741 8.737-19.478 19.478-19.478h6.899a1 1 0 010 2h-6.899C106.841 85.332 99 93.173 99 102.81v20.395c0 5.561 4.526 10.086 10.087 10.086h13.365a1 1 0 010 2h-13.365c-6.666 0-12.087-5.421-12.087-12.086V102.81zM177.315 76.703h-22.63c-9.084 0-16.478 7.394-16.478 16.478v37.412c0 .937.759 1.696 1.696 1.696h52.194c.937 0 1.696-.759 1.696-1.696V93.181c0-9.084-7.394-16.478-16.478-16.478zm-22.63-2h22.63c10.189 0 18.478 8.29 18.478 18.478v37.412a3.696 3.696 0 01-3.696 3.696h-52.194a3.696 3.696 0 01-3.696-3.696V93.181c0-10.189 8.289-18.478 18.478-18.478zM166.001 25.71c-11.149 0-20.222 9.074-20.222 20.223 0 7.557 4.17 14.165 10.343 17.638a20.084 20.084 0 009.879 2.583c3.588 0 6.956-.94 9.879-2.583 6.173-3.473 10.342-10.081 10.342-17.638 0-11.149-9.073-20.222-20.221-20.222zm-22.222 20.223c0-12.254 9.969-22.222 22.222-22.222 12.253 0 22.221 9.969 22.221 22.222 0 8.31-4.587 15.57-11.361 19.38a22.087 22.087 0 01-10.86 2.841 22.084 22.084 0 01-10.86-2.84c-6.774-3.811-11.362-11.07-11.362-19.381zM135.882 67.905a14.509 14.509 0 001.717-6.864c0-8.06-6.56-14.62-14.619-14.62-8.059 0-14.619 6.56-14.619 14.62 0 8.059 6.56 14.618 14.619 14.618 2.046 0 3.991-.423 5.758-1.184m7.144-6.57a14.725 14.725 0 01-7.144 6.57l7.144-6.57zm-29.521-6.864c0-9.164 7.455-16.62 16.619-16.62s16.619 7.456 16.619 16.62c0 2.82-.708 5.477-1.953 7.806a16.726 16.726 0 01-8.117 7.465 16.524 16.524 0 01-6.549 1.347c-9.164 0-16.619-7.455-16.619-16.618zM196.12 67.905a14.72 14.72 0 007.143 6.57 14.522 14.522 0 005.758 1.184c8.059 0 14.619-6.56 14.619-14.618 0-8.06-6.56-14.62-14.619-14.62-8.059 0-14.619 6.56-14.619 14.62 0 2.481.623 4.816 1.718 6.864zm-3.718-6.864c0-9.164 7.455-16.62 16.619-16.62s16.619 7.456 16.619 16.62c0 9.163-7.455 16.618-16.619 16.618-2.324 0-4.538-.481-6.549-1.347a16.718 16.718 0 01-8.116-7.465 16.512 16.512 0 01-1.954-7.806z" fill="#DEE3EA"/><path d="M263.409 64.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091zM28.41 101.467c.195-.107.442-.249.61-.399 1.596-1.421 3.707-1.427 5.31 0 1.056.941 2.422.941 3.479 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.31 0 .152.136.37.276.668.43.367.189.526.674.356 1.083-.17.408-.606.586-.973.396-.41-.212-.718-.414-.967-.636-1.057-.941-2.422-.941-3.48 0-1.596 1.421-3.707 1.427-5.309 0-1.057-.941-2.422-.941-3.48 0-1.596 1.421-3.707 1.427-5.309 0-1.057-.941-2.422-.941-3.48 0-.277.247-.6.436-.878.589-.363.199-.802.032-.98-.372-.18-.404-.03-.892.334-1.091zM272.409 70.467c.196-.107.443-.25.611-.399 1.596-1.421 3.707-1.427 5.309 0 1.057.941 2.423.941 3.48 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.309 0 .153.136.371.276.669.43.367.19.526.674.356 1.083-.17.408-.606.585-.973.396-.411-.212-.718-.414-.967-.636-1.057-.94-2.423-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0-1.597 1.422-3.708 1.427-5.31 0-1.057-.94-2.422-.941-3.479 0a4.75 4.75 0 01-.879.59c-.363.198-.802.031-.981-.373-.178-.404-.029-.892.334-1.091zM37.41 107.467c.195-.107.442-.249.61-.399 1.596-1.421 3.707-1.427 5.31 0 1.056.941 2.422.941 3.479 0 .784-.698 1.702-1.067 2.654-1.067.953 0 1.871.369 2.655 1.067 1.057.941 2.423.941 3.48 0 1.596-1.421 3.707-1.427 5.31 0 .152.136.37.276.668.43.367.189.526.674.356 1.083-.17.408-.606.586-.973.396-.41-.212-.718-.414-.967-.636-1.057-.941-2.422-.941-3.48 0-1.596 1.421-3.707 1.427-5.309 0-1.057-.941-2.422-.941-3.48 0-1.596 1.421-3.707 1.427-5.309 0-1.057-.941-2.422-.941-3.48 0-.276.247-.6.436-.878.589-.363.199-.802.032-.98-.372-.18-.404-.03-.892.334-1.091z" fill="#DEE3EA"/></svg>
      <div class="m-t-4 m-b-3">Clients list is empty</div>
      <router-link to="/counterparties/add-counterparties" class="text-blue fz14">Create a new client</router-link>
    </div>

    <div class="counterparties-list_data">
      <div class="counterparties-list_row cursor-pointer" v-for="client in clients" :key="client.id"  @click.stop="toUser(client.id)">
        <div class="counterparties-list_col check" @click.stop><b-form-checkbox v-model="checkedList" :value="client.id"></b-form-checkbox></div>

        <div class="counterparties-list_col name">{{client.company_name}}</div>
        <div 
          class="counterparties-list_col full-name svg-white-dart"
          :class="{empty: !client.full_style}"
        >
          <div v-if="client.full_style" ref="full_name" @click.stop="onCopy(client.full_style)">
            <pre>{{client.full_style}}</pre>
            <svg class="counterparties-list_col__copy" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 5.17189C0 4.13178 0.854394 3.28861 1.90834 3.28861H8.94561C9.99956 3.28861 10.854 4.13178 10.854 5.17189V12.1167C10.854 13.1568 9.99956 14 8.94561 14H1.90834C0.854394 14 0 13.1568 0 12.1167V5.17189ZM1.90834 4.60405C1.59056 4.60405 1.33294 4.85828 1.33294 5.17189V12.1167C1.33294 12.4303 1.59056 12.6846 1.90834 12.6846H8.94561C9.2634 12.6846 9.52101 12.4303 9.52101 12.1167V5.17189C9.52101 4.85828 9.2634 4.60405 8.94561 4.60405H1.90834Z" fill="#4B4B4B"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.14605 1.88328C3.14605 0.843172 4.00044 0 5.05439 0H12.0917C13.1456 0 14 0.843172 14 1.88328V8.82811C14 9.86822 13.1456 10.7114 12.0917 10.7114C11.7236 10.7114 11.4252 10.4169 11.4252 10.0537C11.4252 9.69042 11.7236 9.39595 12.0917 9.39595C12.4094 9.39595 12.6671 9.14172 12.6671 8.82811V1.88328C12.6671 1.56967 12.4094 1.31543 12.0917 1.31543H5.05439C4.73661 1.31543 4.47899 1.56967 4.47899 1.88328C4.47899 2.24652 4.1806 2.54099 3.81252 2.54099C3.44444 2.54099 3.14605 2.24652 3.14605 1.88328Z" fill="#4B4B4B"/></svg>
          </div>
        </div>
        <div class="counterparties-list_col subtype"><div v-for="subtype in client.subtype" :key="subtype.id" class="text-dots-overflow">
          {{subtype.name}}
        </div></div>
        <div class="counterparties-list_col broker"><div v-for="broker in client.broker" :key="broker.id">{{broker.name}}</div></div>
        <div class="counterparties-list_col attachment svg-white-dart"><svg v-if="client.files.length" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 16C2.24268 16 0 13.7573 0 11V4C0 3.63135 0.298706 3.33337 0.666626 3.33337C1.03467 3.33337 1.33337 3.63135 1.33337 4V11C1.33337 13.0214 2.97803 14.6666 5 14.6666C7.02197 14.6666 8.66663 13.0214 8.66663 11V3.66663C8.66663 2.38 7.62 1.33337 6.33337 1.33337C5.04663 1.33337 4 2.38 4 3.66663V10.3334C4 10.8846 4.44861 11.3334 5 11.3334C5.55139 11.3334 6 10.8846 6 10.3334V4C6 3.63135 6.29871 3.33337 6.66663 3.33337C7.03467 3.33337 7.33337 3.63135 7.33337 4V10.3334C7.33337 11.62 6.28662 12.6666 5 12.6666C3.71338 12.6666 2.66663 11.62 2.66663 10.3334V3.66663C2.66663 1.64539 4.31128 0 6.33337 0C8.35535 0 10 1.64539 10 3.66663V11C10 13.7573 7.75732 16 5 16Z" fill="#4B4B4B"/></svg></div>
        <div class="counterparties-list_col menu">
          <counterparties-list-option-btn 
            @editItem="editClient(client.id)" 
            @archiveItem="openModal(client)" 
            :canEdit="getPermissionsByType('can_edit_client')" 
            :canArchive="getPermissionsByType('can_archive_client') && client.id !== 41"
          />
        </div>
      </div>
    </div>
    <counterparties-modal-archive v-if="isModalOpen" @close="closeModal" @submit="archiveClient"/>
    <!-- <pre>{{clients}}</pre> -->
  </div>
</template>

<script>
import tippy, {followCursor, hideAll} from 'tippy.js';
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import counterpartiesListOptionBtn from '@/components/counterparties/counterpartiesList/counterpartiesListOptionBtn'
import counterpartiesModalArchive from '@/components/counterparties/counterpartiesList/counterpartiesModalArchive'

export default {
  components: {
    counterpartiesListOptionBtn,
    counterpartiesModalArchive
  },
  data() {
    return {
      indeterminate: false,
      allSelected: false,
      checkedList: [],
      optionClientId: 0,
      optionClientName: '',
      isModalOpen: false
    }
  },
  watch: {
    clients: {
      immediate: true,
      deep: true,
      handler() {
        this.addTippy()
      }
    },
    checkedList(newValue) {
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.clients.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }

      this.$emit('select', this.checkedList)
    }
  },
  computed: {
    ...mapState({
      clients: state => state.counterparties.clients
    }),
    ...mapGetters(['getPermissionsByType'])
  },
  methods: {
    ...mapActions(['axiosClientToArchive']),
    ...mapMutations(['showLoad', 'hideLoad', 'addTip']),
    onCopy(text) {
      this.addTippy()
      this.$copyText(text)
      setTimeout(() => {
        hideAll() // tippy.js
      }, 700)
    },
    editClient(id) {
      this.$router.push('counterparties/edit-counterparties/'+ id)
    },
    async archiveClient() {
      this.closeModal()
      this.showLoad()
      await this.axiosClientToArchive({ids: [this.optionClientId], bool: true})
      this.addTip(this.optionClientName + ' is archived')
      this.hideLoad()
    },
    checkAll(checked) {
      this.checkedList = checked ? this.clients.map((client) => {return client.id}) : []
    },
    uncheckAll() { // used in parent component
      this.checkedList = []
    },
    toUser(id) {
      this.$router.push('counterparties/'+ id)
    },
    openModal(client) {
      this.optionClientId = client.id
      this.optionClientName = client.company_name
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
    async addTippy() {
      await this.$nextTick()
      if(this.$refs.full_name){
        this.$refs.full_name.forEach(el => {
          if(!el._tippy){
            tippy(el, {
              arrow: false,
              duration: [null, null],
              trigger: 'click',
              content: 'Copied to clipboard',
              followCursor: 'initial',
              plugins: [followCursor],
            })
          }
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "./src/components/style-element/bootstrap";
  @import "./src/components/style-element/checkbox";
</style>

<style lang="scss">
  .counterparties-list{
    margin-top: 12px;
    &_row{
      display: flex;
      padding-top: 6px;
      padding-bottom: 6px;
      font-size: 14px;
      line-height: 1.5;
      &:not(:last-of-type){
        border-bottom: 1px solid var(--color-card-border);
      }
      &.head{
        border-bottom: none;
        color: #9AA3B0;
        font-size: 13px;
        .attachment{
          text-align: left;
        }
      }
    }
    &_data{
      background: var(--color-card);
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }
    &_col{
      position: relative;
      box-sizing: border-box;
      flex-shrink: 0;
      padding-right: 10px;
      white-space: nowrap;
      text-overflow: ellipsis;
      &.check{
        width: 4.1%;
        padding-left: 11px;
        .custom-checkbox{
          margin-top: 2px;
        }
      }
      &.name{
        width: 23.6%;
      }
      &.full-name{
        position: relative;
        width: 28.6%;
        white-space: normal;
        padding-right: 58px;
        z-index: 1;
        &:hover{
          &:before{
            opacity: 1;
          }
          svg{
            opacity: 1;
            visibility: visible;
            cursor: pointer;
          }
        }
        pre{
          margin-bottom: 0;
          font-family: 'SFProDisplay', sans-serif;
          font-size: 100%;
        }
        svg{
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
        }
        &:before{
          content: '';
          position: absolute;
          top: -2px;
          left: -4px;
          display: block;
          height: calc(100% + 4px);
          width: calc(100% - 20px);
          background: var(--color-input);
          border-radius: 4px;
          z-index: -1;
          opacity: 0;
          transition: opacity 0.3s;
        }
        &.empty{
          user-select: none;
          cursor: default;
          svg{
            display: none !important;
          }
          &:before{
            opacity: 0 !important;
          }
        }
      }
      &.subtype{
        width: 14.3%;
      }
      &.broker{
        width: 17.3%;
      }
      &.attachment{
        width: 8.4%;
        text-align: center;
      }
      &.menu{
        width: 3.8%;
      }
      &__copy{
        position: absolute;
        top: 3px;
        right: 37px;
      }
    }
    &-empty{
      text-align: center;
      padding-top: 10%;
      font-weight: 500;
      font-size: 18px;
    }
  }
  .tippy{
    &-box{
      background: #4B4B4B;
      box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.15);
      border-radius: 4px;
      padding: 4px;
    }
    &-content{
      font-size: 12px;
      color: #fff;
    }
  }
  .text-dots-overflow {
    display: block !important;
  }
  .counterparties-list_col.name {
    overflow: hidden;
  }
</style>